import React from 'react';
import ReactToggle from 'react-toggle';
import TaxonomySelection from '../../helper/taxonomySelection';
import MetadataSelection from '../../helper/metadataSelection';
import Select from 'react-select';
import { findIndex } from 'underscore';
import clone from 'clone';
import BuildActions from '../../builder/action/builderActions';
import panelActions from '../action/panelActions';
import { stringify } from '../../helper/helperFunction';

class RangeInputPanel extends React.Component {
    constructor(props) {
      super(props);
      this.metakey = '_reactive_builder_' + this.props.shortcodeKey;
      this.handleTaxonomy = this.handleTaxonomy.bind(this);
      this.handleMetakey = this.handleMetakey.bind(this);
      this.handleChangeDataTypes = this.handleChangeDataTypes.bind(this);
      this.handleChangeToogleViewTypes = this.handleChangeToogleViewTypes.bind(this);
      this.handleChangeUnitFix = this.handleChangeUnitFix.bind(this);
      this.handleChangeRangeInputType = this.handleChangeRangeInputType.bind(this);
      this.handleClassName = this.handleClassName.bind(this);
      this.saveData = this.saveData.bind(this);
      this.state = {
        settings: {
          histogramToggle: false,
        },
      };
      this.datatypes = [
        {
          'label': 'Metadata',
          'value': 'metakeys',
        },
      ];
      this.toogleviewtype = [
        {
          'label': 'Toogle Show On',
          'value': 'true',
        },
        {
          'label': 'Toogle Show Off',
          'value': 'false',
        },
      ];
      this.unitFix = [
        {
          label: 'PostFix Unit',
          value: 'postfix',
        }, {
          label: 'PreFix Unit',
          value: 'prefix',
        },
      ];
      this.RangeInputType = [
        {
          label: 'Single',
          value: 'single',
        }, {
          label: 'Double',
          value: 'double',
        },
      ];
      this.settings = {};
    }
    componentWillMount() {
      this.settings = { ...this.props.settings };
      this.setState({
        'settings': { ...this.state.settings, ...this.props.settings },
      });
    }
    componentWillReceiveProps(nextProps) {
      if (nextProps.childUid !== this.props.childUid) {
        this.setState({
          'settings': { ...this.state.settings, ...nextProps.settings },
        });
        this.settings = {};
      }
    }
    handleTaxonomy(val) {
      const value = val === null ? null : val.value;
      this.settings.selectedTaxonomy = value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handleMetakey(val) {
      const value = val === null ? null : val.value;
      this.settings.selectedMetakey = value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handleChangeUnitFix(val) {
      const value = val === null ? null : val.value;
      this.settings.selectedUnitFix = value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handleChangeDataTypes(val) {
      const value = val === null ? null : val.value;
      this.settings.selectedDataType = value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handelTitle(e) {
      this.settings.title = e.target.value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handelMaxValue(e) {
      this.settings.maxvalue = e.target.value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handelMinValue(e) {
      this.settings.minvalue = e.target.value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handleChangeToogleViewTypes(val) {
      this.settings.selectedToogleViewType = val.target.checked;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handleChangeRangeInputType(val) {
      this.settings.selectedRangeType = val === null ? null : val.value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handelSubTitle(e) {
      this.settings.subtitle = e.target.value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handleRangeUnit(e) {
      this.settings.unit = e.target.value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handleHistogramToggle() {
      if (this.state.settings.histogramToggle === 'false' || this.state.settings.histogramToggle === false) {
        this.settings.histogramToggle = true;
      } else {
        this.settings.histogramToggle = false;
      }
      this.setState({
        settings: { ...this.settings },
      });
    }
    handleClassName(e) {
      this.settings.dynamicNameClassCheckBox = e.target.value;
      this.setState({
        settings: { ...this.state.settings, ...this.settings },
      });
    }
    saveData(e) {
      e.preventDefault();
      const allLayout = clone(this.props.allLayout);
      const find = findIndex(allLayout, { uid: this.props.uid });
      if (find !== -1) {
        const findSearchIndex = findIndex(allLayout[find].searchAttr, { uid: this.props.childUid });
        if (findSearchIndex !== -1) {
          allLayout[find].searchAttr[findSearchIndex] = Object.assign(allLayout[find].searchAttr[findSearchIndex], this.state.settings);
        }
      }
      const pushLayout = {
        allLayout,
        'shortcodeKey': this.props.shortcodeKey,
      };
      BuildActions.saveAllBlocks(pushLayout);
      panelActions.togglePanel('', this.props.shortcodeKey);
    }
    render() {
      return (<div>
        <button className="layout-save-button" onClick={this.saveData}><i className="fa fa-floppy-o"></i><span>Save</span></button>
        <div className="reactive-tab-setting">
          <ul className="nav nav-tabs" role="tablist">
            <li role="presentation" className="active"><a href="#appearance" aria-controls="general" role="tab" data-toggle="tab">Appearance</a></li>
            <li role="presentation"><a href="#populate" aria-controls="populate" role="tab" data-toggle="tab">Data</a></li>
          </ul>
          <div className="tab-content">
            <div role="tabpanel" className="tab-pane active" id="appearance">
              <input type="text" className="reactive-input" value= {stringify(this.state.settings.title)} onChange= { this.handelTitle.bind(this) } placeholder={API.LANG.PLEASE_ENTER_THE_TITLE}/>
              <input type="text" className="reactive-input" value= {stringify(this.state.settings.subtitle)} onChange= { this.handelSubTitle.bind(this) } placeholder={API.LANG.PLEASE_ENTER_THE_SUBTITLE}/>
              <input type="text" className="reactive-input" value= {this.state.settings.unit} onChange= { this.handleRangeUnit.bind(this) } placeholder={API.LANG.ENTER_UNIT}/>
              <input type="text" className="reactive-input" value= {this.state.settings.dynamicNameClassCheckBox} onChange= { this.handleClassName.bind(this) } placeholder={API.LANG.PLEASE_ENTER_THE_CUSTOM_CSS_CLASSNAME}/>
              <div className="flex-row">
                <div className="flex-md-6 flex-xs-12">
                  <input type="text" className="reactive-input" value= {this.state.settings.minvalue} onChange= { this.handelMinValue.bind(this) } placeholder={API.LANG.PLACE_MIN_VAL}/>
                </div>
                <div className="flex-md-6 flex-xs-12">
                  <input type="text" className="reactive-input" value= {this.state.settings.maxvalue} onChange= { this.handelMaxValue.bind(this) } placeholder={API.LANG.PLACE_MAX_VAL}/>
                </div>
              </div>
              <div className="grid-choose-option">
                <div className="flex-row ">
                  <div className="flex-sm-3 flex-xs-12">
                    <span className="caption">{API.LANG.TOGGLE_OPTION}</span>
                  </div>
                  <div className="flex-sm-9 flex-xs-12">
                    <div className="choose-grid-button">
                      <ReactToggle
                        defaultChecked={this.state.settings.selectedToogleViewType === 'true' || this.state.settings.selectedToogleViewType === true}
                        onChange={this.handleChangeToogleViewTypes.bind(this)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="grid-choose-option">
                <div className="flex-row ">
                  <div className="flex-sm-3 flex-xs-12">
                    <span className="caption">{API.LANG.UNIT_OPTION}</span>
                  </div>
                  <div className="flex-sm-9 flex-xs-12">
                    <div className="choose-grid-button">
                      <Select
                        name="form-field-name"
                        placeholder={'PostFix/Prefix Unit'}
                        value={this.state.settings.selectedUnitFix}
                        options={this.unitFix}
                        onChange={this.handleChangeUnitFix}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="grid-choose-option">
                <div className="flex-row ">
                  <div className="flex-sm-3 flex-xs-12">
                    <span className="caption">{API.LANG.RANGE_TYPE}</span>
                  </div>
                  <div className="flex-sm-9 flex-xs-12">
                    <div className="choose-grid-button">
                      <Select
                        name="form-field-name"
                        placeholder={'Double/Single'}
                        value={this.state.settings.selectedRangeType}
                        options={this.RangeInputType}
                        onChange={this.handleChangeRangeInputType}
                      />
                    </div>
                  </div>
                </div>
              </div>
              { /**
              <div className="flex-row">
                <div className="flex-sm-3 flex-xs-12">
                  <span className="caption">{API.LANG.SHOW_HISTOGRAM_TOGGLE}</span>
                </div>
                <div className="flex-md-6 flex-xs-12">
                  <ReactToggle
                    defaultChecked={this.state.settings.histogramToggle === 'true' || this.state.settings.histogramToggle === true}
                    onChange={this.handleHistogramToggle.bind(this)}
                  />
                </div>
              </div>
            **/ }

            </div>
            <div role="tabpanel" className="tab-pane" id="populate">
          { /**
            Please select data type
          */}
          <div className="flex-row">
            <div className="flex-sm-6 flex-md-6 flex-xs-12">
              <Select
                name="form-field-name"
                placeholder={API.LANG.PLEASE_ENTER_A_DATA_TYPE}
                value={this.state.settings.selectedDataType}
                options={this.datatypes}
                onChange={this.handleChangeDataTypes}
              />
            </div>
          </div>

            { this.state.settings.selectedDataType === 'taxonomies' ? <TaxonomySelection onTaxonomySelection={this.handleTaxonomy} value={this.state.settings.selectedTaxonomy} {...this.props} /> : null }
            { this.state.settings.selectedDataType === 'metakeys' ? <MetadataSelection onMetakeySelection={this.handleMetakey} value={this.state.settings.selectedMetakey} {...this.props} /> : null }


            </div>
          </div>
        </div>

      </div>);
    }
}


RangeInputPanel.propTypes = {
  'shortcodeKey': React.PropTypes.number,
  'uid': React.PropTypes.string,
  'childUid': React.PropTypes.string,
  'allLayout': React.PropTypes.array,
  'settings': React.PropTypes.object,
};

export default RangeInputPanel;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/panel/search/rangeinputPanel.js
 **/